// components/ProcesoPago.jsx
// Overlay del proceso de pago con la animación de pasos (como el modal ONT).
// Si el cliente estaba SUSPENDIDO, al final muestra una pantalla de
// resultado grande e inconfundible: servicio reconectado o error.
//
// props.proceso:
//   null                                  -> no se muestra nada
//   { fase:"trabajando", pasos:[...] }    -> spinner + pasos animados
//   { fase:"resultado", reconexion:{ok,mensaje} } -> pantalla de resultado
import React, { useEffect, useRef, useState } from "react";
import "./ProcesoPago.css";

export default function ProcesoPago({ proceso, onClose }) {
  const [paso, setPaso] = useState(0);
  const timerRef = useRef(null);

  const trabajando = proceso?.fase === "trabajando";
  const pasos = proceso?.pasos || [];

  useEffect(() => {
    clearInterval(timerRef.current);
    if (trabajando) {
      setPaso(0);
      timerRef.current = setInterval(() => {
        setPaso((p) => (p < pasos.length - 1 ? p + 1 : p));
      }, 1500);
    }
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trabajando, proceso]);

  if (!proceso) return null;

  const recon = proceso.reconexion;
  const diag = proceso.diag; // verificación REAL de la ONT (fibra)

  // Veredicto:
  //  - FIBRA con diagnóstico: manda lo VERIFICADO en el OLT (control flag)
  //  - WiFi o sin diagnóstico: lo que reportó la reconexión
  const ontActiva = diag?.ont?.control_flag === "active";
  const exito = diag ? ontActiva : recon?.ok === true;
  const enLinea = diag?.ont?.run_state === "online";

  return (
    <div className="pp-overlay">
      <div className="pp-modal">
        {trabajando ? (
          <>
            <h3 className="pp-titulo">{proceso.titulo || "Procesando pago"}</h3>
            <div className="pp-proceso">
              <div className="pp-spinner" />
              <ul className="pp-pasos">
                {pasos.map((texto, i) => {
                  const estado = i < paso ? "hecho" : i === paso ? "actual" : "pend";
                  return (
                    <li key={i} className={`pp-paso ${estado}`}>
                      <span className="pp-paso-ic">{estado === "hecho" ? "✓" : ""}</span>
                      {texto}
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        ) : (
          <>
            {/* ---- RESULTADO con la verificación real de la ONT ---- */}
            <div className={`pp-resultado ${exito ? "ok" : "warn"}`}>
              <div className="pp-icono">{exito ? "📡" : "⚠️"}</div>
              <h2 className="pp-res-titulo">
                {exito ? "SERVICIO RECONECTADO" : "REVISAR SERVICIO"}
              </h2>

              <div className="pp-lineas">
                <div className="pp-linea ok">✅ Pago registrado correctamente</div>

                {diag ? (
                  <>
                    <div className={`pp-linea ${ontActiva ? "ok" : "warn"}`}>
                      {ontActiva ? "✅" : "⚠️"} ONT:{" "}
                      <strong>{ontActiva ? "activa" : "desactivada"}</strong>
                      {diag.ont?.run_state
                        ? ` (${enLinea ? "en línea" : diag.ont.run_state})`
                        : ""}{" "}
                      — verificado en el OLT
                    </div>
                    {diag.ont?.serial && (
                      <div className="pp-linea">🏷️ Serial: <strong>{diag.ont.serial}</strong></div>
                    )}
                  </>
                ) : (
                  <div className={`pp-linea ${recon?.ok ? "ok" : "warn"}`}>
                    {recon?.ok ? "✅" : "⚠️"} {recon?.mensaje || "Reconexión sin confirmar"}
                  </div>
                )}
              </div>

              {!exito && (
                <p className="pp-res-msg">
                  Verifica con el botón ⏻ del cliente antes de despedirlo.
                </p>
              )}
            </div>
            <div className="pp-botones">
              <button className={`pp-boton ${exito ? "ok" : "warn"}`} onClick={onClose}>
                Entendido
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
